<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")
</template>

<script>
import { mapState } from 'vuex';
import numeral from 'numeral';
import Unleash from '@js/plugins/unleash';

export default {
    props: {
        payments: {
            type: Array,
            required: true,
        },
    },

    data() {
        var that = this;

        return {
            tableName: 'TRANSACTION_BREAKDOWN_DETAILS',
            columns: ['receipt_date', 'total'].concat(this.payments),
            options: {
                useReportFilter: true,
                columnsDropdown: true,
                filterable: false,
                perPage: 2000,
                perPageValues: [2000],
                texts: {
                    title: this.trans('report.transaction_breakdown_details'),
                    description: 'Shows transaction breakdown by payment type',
                },
                headings: {
                    receipt_date: 'Receipt Date',
                    ipt: 'IPT',
                    edc: 'EDC',
                    on_account: 'On Account',
                    'e_-_voucher': 'E-Voucher',
                    opt: 'OPT',
                    qr_pay: 'Qr Pay',
                    cash: 'Cash',
                    credit_card: 'Credit Card',
                    setel: 'Setel',
                    mesra: 'Mesra cardless',
                    gift_card: 'Gift Card',
                    smartpay: 'SmartPay',
                    e_wallet: 'E-Wallet',
                    voucher: 'Voucher',
                    others: 'Others',
                },
                pdf_url: Laroute.route(
                    'franchise.report.transaction.breakdown_details_export',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.transaction.breakdown_details_export',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.transaction.breakdown_details_export',
                    { type: 'XLSX' },
                ),

                responseAdapter: res => {
                    const data = res.data.data.map(data => {
                        const paymentList = {};

                        this.payments.forEach(p => {
                            paymentList[p] = this.numberFormat(data[p]);
                        });

                        return Object.assign(
                            {
                                receipt_date: moment(data.receipt_date)
                                    .format('dddd, DD MMM YYYY')
                                    .toUpperCase(),
                                total: this.numberFormat(data.total),
                            },
                            paymentList,
                        );
                    });

                    return {
                        data,
                        count: res.data.count,
                    };
                },

                columnsClasses: {
                    receipt_date: 'text-left',
                    total: 'text-right',
                    cash: 'text-right',
                    ipt: 'text-right',
                    edc: 'text-right',
                    on_account: 'text-right',
                    'e_-_voucher': 'text-right',
                    opt: 'text-right',
                    setel: 'text-right',
                    voucher: 'text-right',
                    mesra_cardless: 'text-right',
                    qr_pay: 'text-right',
                    'e-wallet': 'text-right',
                },
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        datatableUrl() {
            return Laroute.route(
                'franchise.report.transaction.breakdown_details',
            );
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },
    },

    created() {
        this.removeLimitState();
        this.setHeadings();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    methods: {
        numberFormat(total) {
            return numeral(total).format('0,0.00');
        },

        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 2000;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },

        setHeadings() {
            this.isEnableQrMop = Unleash.hasFeature('qr_mop');

            this.columns = ['receipt_date', 'total'].concat(this.payments);

            const baseHeadings = {
                receipt_date: 'Receipt Date',
                total: 'Total',
            };

            const baseClasses = {
                receipt_date: 'text-left',
                total: 'text-right',
            };

            const paymentDisplayNames = {
                cash: 'Cash',
                ipt: 'IPT',
                edc: 'EDC',
                opt: 'OPT',
                on_account: 'On Account',
                setel: 'Setel',
                'e_-_voucher': 'E-Voucher',
                voucher: 'Voucher',
                mesra_cardless: 'Mesra Cardless',
                qr_pay: 'QR Pay',
                'e-wallet': 'E-Wallet',
            };

            this.payments.forEach(payment => {
                baseHeadings[payment] =
                    paymentDisplayNames[payment] ||
                    payment
                        .split('_')
                        .map(
                            word =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                        );

                baseClasses[payment] = 'text-right';
            });

            if (!this.isEnableQrMop) {
                this.columns = this.columns.filter(
                    column => column !== 'qr_pay',
                );
                delete baseHeadings.qr_pay;
                delete baseClasses.qr_pay;
            }

            this.options.headings = baseHeadings;
            this.options.columnsClasses = baseClasses;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/transaction-breakdown-details.vue